import { useGetCurrentPageTitle } from '@legacy/stores/PageStore/pageStore.zustand';

interface BrowserTitleProps {
  title?: string;
}

export const BrowserTitle = ({ title }: BrowserTitleProps) => {
  const currentPageTitle = useGetCurrentPageTitle();

  const browserTitle = currentPageTitle || title;

  return (
    <title>
      {browserTitle ? `${browserTitle} - TimeLog PSA` : 'TimeLog PSA'}
    </title>
  );
};
